import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import ErrorBoundary from 'components/ErrorBoundary';
import 'isomorphic-fetch';
import '@chewy/kib-normalize/dist/kib-normalize-no-fonts.css';
import '@chewy/kib-css-helpers/dist/kib-css-helpers.css';
import './styles/global.scss';
import './document.scss';

const Document = ({ children }: { children: ReactNode }) => (
  <div className="chewy-pet-profile-app">
    <Helmet defaultTitle="Pet Food, Products, Supplies at Low Prices | Chewy" />
    <ErrorBoundary>
      <main>{children}</main>
    </ErrorBoundary>
  </div>
);

export default Document;
